import styled from "styled-components";

export const MarkdownWrapper = styled.div`
    width: 100%;
    height: 100%;
`;
